import axios from 'axios';

// Створюємо екземпляр axios з базовим URL
const apiClient = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 
    'https://profbonus.chnu.edu.ua/api' : 
    'http://localhost:8080/api',  // ВИПРАВЛЕНО: правильний URL для локальної розробки
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000, // 15 секунд таймаут
  withCredentials: true, // Важливо для CORS з аутентифікацією
});

// Додаємо інтерцептор для додавання токена до запитів
apiClient.interceptors.request.use(
  (config) => {
    // Отримуємо токен з localStorage
    const token = localStorage.getItem('token');
    
    // Додаємо токен у заголовок, якщо він існує
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Для розробки логуємо детальну інформацію
    if (process.env.NODE_ENV !== 'production') {
      console.log(`📤 API Request [${config.method?.toUpperCase()}] ${config.url}`, { 
        hasToken: !!token,
        headers: config.headers,
        data: config.data,
        baseURL: config.baseURL
      });
    }
    
    return config;
  },
  (error) => {
    console.error('❌ API Request Config Error:', error);
    return Promise.reject(error);
  }
);

// Додаємо інтерцептор для обробки відповідей
apiClient.interceptors.response.use(
  (response) => {
    // Для розробки логуємо відповіді
    if (process.env.NODE_ENV !== 'production') {
      console.log(`📥 API Response [${response.status}] ${response.config.url}`, {
        data: response.data,
        headers: response.headers
      });
    }
    
    return response;
  },
  (error) => {
    // Детальна обробка помилок
    if (error.response) {
      // Сервер відповів з помилкою
      console.error(`❌ API Error [${error.response.status}] ${error.config?.url}`, {
        data: error.response.data,
        message: error.message,
        headers: error.response.headers
      });
      
      // Спеціальна обробка помилки 401 (Unauthorized)
      if (error.response.status === 401) {
        const currentPath = window.location.pathname;
        
        // Не перенаправляємо на login, якщо ми вже там
        if (currentPath !== '/login' && 
            currentPath !== '/register' && 
            currentPath !== '/oauth-callback') {
          console.log('🔐 Unauthorized access detected, clearing session...');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
      }
      
      // Обробка помилки 403 (Forbidden)
      if (error.response.status === 403) {
        console.error('🚫 Доступ заборонено:', error.response.data);
      }
      
    } else if (error.request) {
      // Запит був зроблений, але відповіді не отримано
      console.error('❌ API Network Error - No response received:', {
        request: error.request,
        message: error.message
      });
      console.error('💡 Можливі причини:');
      console.error('   1. Backend сервер не запущений на http://localhost:8080');
      console.error('   2. CORS блокує запит');
      console.error('   3. Проблеми з мережею');
      
    } else {
      // Щось пішло не так при налаштуванні запиту
      console.error('❌ API Request Setup Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Додаємо допоміжні методи для тестування
if (process.env.NODE_ENV !== 'production') {
  window.testAPI = {
    // Тестовий метод для перевірки з'єднання
    testConnection: async () => {
      try {
        console.log('🧪 Testing API connection...');
        const response = await apiClient.get('/auth/test');
        console.log('✅ API connection successful:', response.data);
        return true;
      } catch (error) {
        console.error('❌ API connection failed:', error);
        return false;
      }
    },
    
    // Отримати поточну конфігурацію
    getConfig: () => ({
      baseURL: apiClient.defaults.baseURL,
      timeout: apiClient.defaults.timeout,
      withCredentials: apiClient.defaults.withCredentials,
      hasToken: !!localStorage.getItem('token')
    })
  };
  
  console.log('🔧 API Client initialized:', window.testAPI.getConfig());
}

export default apiClient;